import { z } from 'zod';

export const healthCheckSchema = z.object({
  status: z.enum(['ok', 'error']),
  timestamp: z.string(),
  dbTime: z.string().optional(),
  version: z.string(),
});

export type HealthCheckResponse = z.infer<typeof healthCheckSchema>;

export * from './auth.js';
export * from './matchmaking.js';
export * from './rooms.js';
export * from './sayings.js';
